import RouteTemplate from 'ember-route-template';

import { hash } from '@ember/helper';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

import ExpandingBlock from 'rise-ui/components/expanding-block.gjs';
import Sticky from 'rise-ui/components/sticky.gjs';
import TimeSeriesOutputAll from 'rise-ui/components/time-series/output/all.gjs';
import TimeSeriesOutputHelp from 'rise-ui/components/time-series/output/help.gjs';
import TimeSeriesOutputLine from 'rise-ui/components/time-series/output/line.gjs';
import set from 'rise-ui/helpers/set.js';
import sticky from 'rise-ui/modifiers/sticky.js';
import { or, readOnly } from 'rise-ui/utils/object/computed';

export default RouteTemplate(class TimeSeriesOutputTemplate extends Component {
  @service('time-series/graph-results') graphResults;
  @service ssr;

  graphs = new Set();

  @or('graphResults.isLoadingOutputs', 'ssr.isSsr') isLoading;
  @readOnly('graphResults.outputs') outputs;

  @action onGraphInit(graph) {
    this.graphs.add(graph);
  }
  @action onGraphDestroy(graph) {
    this.graphs.delete(graph);
  }
  @action onGraphInteract(graph) {
    // Explicitly clear hover cursor on other graphs on interaction
    for (const g of this.graphs) {
      if (g !== graph) {
        g.clearHover();
      }
    }
  }

  onClickPlotButton = this.graphResults.toggle;

  <template>
    {{pageTitle "Generate Plots and Download Time Series Data"}}

    {{#let (hash) as | ctx |}}
    <div class="c-time-series-output c-section">

      {{#if this.isLoading}}
        <div class="c-no-result c-search__results-empty qa-output-loading">
          Loading outputs...
        </div>
      {{else if this.outputs.length}}
        <Sticky @name="help">
          <ExpandingBlock @button={{true}} @onToggle={{set ctx "isStickyHelpShown"}}>
            <:head>
              {{if ctx.isStickyHelpShown "Hide" "Show"}} Instructions
            </:head>
            <:body>
              <TimeSeriesOutputHelp />
            </:body>
          </ExpandingBlock>
        </Sticky>

        <ExpandingBlock @button={{true}}
          @onToggle={{set ctx "isHelpShown"}}
          {{sticky activate="help"}}
        >
          <:head>
            {{if ctx.isHelpShown "Hide" "Show"}} Instructions
          </:head>
          <:body>
            <TimeSeriesOutputHelp />
          </:body>
        </ExpandingBlock>

        <TimeSeriesOutputAll />
        {{#each this.outputs as | results index |}}
          <TimeSeriesOutputLine
            @results={{results}}
            @onGraphInit={{this.onGraphInit}}
            @onGraphDestroy={{this.onGraphDestroy}}
            @onGraphInteract={{this.onGraphInteract}}
            @onClickPlotButton={{this.onClickPlotButton}}
          />
        {{/each}}
      {{else}}
        <div class="c-no-result c-search__results-empty qa-output-empty">
          Please select locations and specify your query in order to generate outputs.
        </div>
      {{/if}}

    </div>
    {{/let}}
  </template>
});
